import { ArrowIcon } from "assets/icons";
import cn from "classnames";
import { useBoolean } from "hooks";
import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "ui";

import { SHORT_PRODUCT_DETAILS_LIST_LENGHT } from "../../../../constants";
import { getProductDetailsInfoList } from "../../../../helpers";
import {
  ProductDetailsListItem,
  ProductDetailsListProps
} from "./ProductDetailsList.types";

import styles from "./ProductDetailsList.module.scss";

const ProductDetailsList = ({
  product,
  activeProductVariant,
  selectedSizeValueId
}: ProductDetailsListProps) => {
  const { t } = useTranslation();

  const { value: isFullListShown, toggle: toggleIsFullListShown } =
    useBoolean(false);

  const selectedSizeBarcode = activeProductVariant.barcodes.find(
    (barcode) => barcode.sizeAttributeValueId === selectedSizeValueId
  )?.value;

  const productDetailsInfoList = useMemo(() => {
    return isFullListShown
      ? getProductDetailsInfoList({
          product,
          activeProductVariant
        })
      : getProductDetailsInfoList({
          product,
          activeProductVariant
        }).slice(0, SHORT_PRODUCT_DETAILS_LIST_LENGHT);
  }, [isFullListShown, product, activeProductVariant]);

  const RowItem = ({ title, value }: ProductDetailsListItem) => (
    <div className={styles.productDetailsList_row}>
      <div className={styles.productDetailsList_row_title}>{t(title)}</div>
      <div>{t(String(value))}</div>
    </div>
  );

  return (
    <div
      className={styles.productDetailsList}
      data-testid="productInfo--details"
    >
      {RowItem({ title: "SKU", value: activeProductVariant.sku })}
      {RowItem({ title: "Short ID", value: activeProductVariant.shortId })}
      {RowItem({ title: t("Barcode"), value: selectedSizeBarcode as string })}

      {productDetailsInfoList.map(({ title, value }, index) => (
        <Fragment key={index}>{RowItem({ title, value })}</Fragment>
      ))}

      <button
        className={cn(styles.productDetailsList_viewMoreBtn, {
          [styles.productDetailsList_viewMoreBtn__active]: isFullListShown
        })}
        onClick={toggleIsFullListShown}
      >
        <Icon
          as={ArrowIcon}
          boxSize={20}
          className={styles.productDetailsList_viewMoreBtn_icon}
        />
        {isFullListShown ? t("Hide") : t("View More")}
      </button>
    </div>
  );
};

export default ProductDetailsList;
